import * as React from 'react';

export const IconCourseSocialFacebook = props => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.415 22l-.029-9.091H5.75V9.273h3.636V7c0-3.374 2.09-5 5.1-5 1.441 0 2.68.107 3.041.155v3.526l-2.087.001c-1.637 0-1.954.778-1.954 1.92v1.67h4.764l-1.818 3.637h-2.946v9.09H9.415z"
      />
    </svg>
  );
};
